import { MenuItem } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';

import { SelectItem } from 'bones/utils/select/types';

export const createNewSelectItemRenderer =
  <
    SubItemType extends SelectItem | null,
    ItemType extends SelectItem<SubItemType>
  >({
    createText = (query: string) => `Create "${query}"`,
    allowDuplicates = false,
  }: {
    createText?: (query: string) => string;
    allowDuplicates?: boolean;
  }) =>
  (items: ItemType[], testId?: string) =>
  // eslint-disable-next-line react/display-name
  (
    query: string,
    active: boolean,
    handleClick: React.MouseEventHandler<HTMLElement>
  ) => {
    // eslint-disable-next-line react/destructuring-assignment
    const trimmedQuery = query.trim();
    if (
      !trimmedQuery ||
      (!allowDuplicates &&
        items.some(
          (item) => item.text.toLowerCase() === trimmedQuery.toLowerCase()
        ))
    ) {
      return undefined;
    }

    return (
      <MenuItem
        active={active}
        data-testid={testId}
        icon={IconNames.ADD}
        onClick={handleClick}
        shouldDismissPopover={false}
        text={createText(trimmedQuery)}
      />
    );
  };
